var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTourPackages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 172.366,
    height: 134.132,
    viewBox: "0 0 172.366 134.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3030",
    "data-name": "Rectangle 3030",
    width: 155.634,
    height: 2.452,
    fill: "#cbd3ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4230",
    "data-name": "Group 4230",
    transform: "translate(-786.498 -400.272)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3103",
    "data-name": "Rectangle 3103",
    width: 6.957,
    height: 6.957,
    transform: "matrix(0.866, -0.5, 0.5, 0.866, 905.479, 412.886)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5570",
    "data-name": "Path 5570",
    d: "M78,194.779,81.016,184.4,71.3,187.933Z",
    transform: "translate(865.988 338.665)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5571",
    "data-name": "Path 5571",
    d: "M129.914,40.807a3.207,3.207,0,1,1-3.207-3.207A3.181,3.181,0,0,1,129.914,40.807Z",
    transform: "translate(663.498 419.257)",
    fill: "none",
    stroke: "#e7f8fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4126",
    "data-name": "Group 4126",
    transform: "translate(793.414 400.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4121",
    "data-name": "Group 4121",
    transform: "matrix(0.978, -0.208, 0.208, 0.978, 0, 13.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4092",
    "data-name": "Group 4092",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M17.417,6.737C36,3.613,45.262,2.078,49.286,1.39,53.256.7,62.467,1.972,63.05,5.519c.582,3.6-7.464,5.188-11.911,5.929-4.394.741-24.669,3.388-28.11,3.97s-13.976,0-16.411-3.547C4.129,8.325,0,.384,0,.384S4.606-1.1,7.57,1.761C10.429,4.672,15.723,7,17.417,6.737Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#2189ff",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.854
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M0,2.645c.106.688,6.67.212,7.782,0s1.906-.9,1.8-1.641C9.477.315,8.471-.161,7.36.051,6.3.263-.1,1.9,0,2.645Z",
    transform: "translate(0.899 9.915)",
    fill: "#536dfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M4.712,0C4.553.053,0,.794,0,.794l1.641,1.8L8.205,1.482",
    transform: "translate(53.415 2.025)",
    fill: "#c4cdfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M.016,1.17a1.061,1.061,0,0,0,1.165.847A1.061,1.061,0,0,0,2.028.852,1.061,1.061,0,0,0,.863.005.992.992,0,0,0,.016,1.17Z",
    transform: "translate(46.834 4.667)",
    fill: "#c4cdfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5584",
    "data-name": "Path 5584",
    d: "M.006,1.17a1.061,1.061,0,0,0,1.165.847A1.061,1.061,0,0,0,2.017.852,1.061,1.061,0,0,0,.853.005,1.02,1.02,0,0,0,.006,1.17Z",
    transform: "translate(42.61 5.355)",
    fill: "#c4cdfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5585",
    "data-name": "Path 5585",
    d: "M.016,1.17a1.061,1.061,0,0,0,1.165.847A1.061,1.061,0,0,0,2.028.852,1.061,1.061,0,0,0,.863.005,1.049,1.049,0,0,0,.016,1.17Z",
    transform: "translate(38.364 6.044)",
    fill: "#c4cdfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5586",
    "data-name": "Path 5586",
    d: "M.018,1.17a1.061,1.061,0,0,0,1.165.847A1.061,1.061,0,0,0,2.03.852,1.061,1.061,0,0,0,.865.005.983.983,0,0,0,.018,1.17Z",
    transform: "translate(34.127 6.785)",
    fill: "#c4cdfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5587",
    "data-name": "Path 5587",
    d: "M.016,1.17a1.061,1.061,0,0,0,1.165.847A1.061,1.061,0,0,0,2.028.852,1.061,1.061,0,0,0,.863.005,1.049,1.049,0,0,0,.016,1.17Z",
    transform: "translate(29.894 7.473)",
    fill: "#c4cdfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5588",
    "data-name": "Path 5588",
    d: "M.018,1.17a1.061,1.061,0,0,0,1.165.847A1.061,1.061,0,0,0,2.03.852,1.061,1.061,0,0,0,.865.005.959.959,0,0,0,.018,1.17Z",
    transform: "translate(25.657 8.214)",
    fill: "#c4cdfa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5589",
    "data-name": "Path 5589",
    d: "M.018,1.17a1.061,1.061,0,0,0,1.165.847A1.061,1.061,0,0,0,2.03.852,1.061,1.061,0,0,0,.865.005.983.983,0,0,0,.018,1.17Z",
    transform: "translate(21.422 8.902)",
    fill: "#c4cdfa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4093",
    "data-name": "Group 4093",
    transform: "translate(10.058 5.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5590",
    "data-name": "Path 5590",
    d: "M0,8.788a33.569,33.569,0,0,0,12.917,1.323c3.441-.582,23.716-3.229,28.11-3.97S53.574,3.759,52.938.212c0-.053-.053-.159-.053-.212Z",
    transform: "translate(0 0)",
    fill: "#c4cdfa"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5591",
    "data-name": "Path 5591",
    d: "M0,3.992c.106.688,13.076-.847,15.3-1.271C17.524,2.351,20.012,1.4,19.853.71c-.106-.688-2.806-.9-5.029-.529C12.654.6-.157,3.3,0,3.992Z",
    transform: "translate(26.044 11.533)",
    fill: "#536dfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5592",
    "data-name": "Path 5592",
    d: "M17.417,6.737C36,3.613,45.262,2.078,49.286,1.39,53.256.7,62.467,1.972,63.05,5.519c.582,3.6-7.464,5.188-11.911,5.929-4.394.741-24.669,3.388-28.11,3.97s-13.976,0-16.411-3.547C4.129,8.325,0,.384,0,.384S4.606-1.1,7.57,1.761C10.429,4.672,15.723,7,17.417,6.737Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4124",
    "data-name": "Group 4124",
    transform: "translate(9.317 36.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5371",
    "data-name": "Path 5371",
    d: "M38.783,123.132H27.009v-6.255H24.985v-4.231h-1.84v-4.415H20.57V104h-.552v4.231H17.259v4.415h-1.84v4.231H13.4v15.269H-4.817v-8.462h-1.84V112.278H-9.048v-2.943h-1.288v-1.656H-21.557v1.656h-1.288v2.943h-2.392v11.406h-2.208v26.123H-29.1v23.915l81.128-.368V124.972H38.783Z",
    transform: "translate(80.978 -104)",
    fill: "#d7f4fc",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5372",
    "data-name": "Path 5372",
    d: "M35.9,134.168v-3.5H34.241V124.6H32.585v-2.759h-.92V114.3h-.184v7.543h-.92V124.6H28.906v3.311H17.5v37.161H37.92V134.168Z",
    transform: "translate(117.714 -95.352)",
    fill: "#d7f4fc",
    opacity: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5373",
    "data-name": "Path 5373",
    d: "M-11.677,109.1H-21.8v5.151H-26.21v4.6h-5.519v18.58h-8.462V123.265l-12.51,6.991v14.165l-4.6,2.208v22.444h0l49.67.368V114.251h-4.047Z",
    transform: "translate(57.3 -99.718)",
    fill: "#d7f4fc",
    opacity: 0.59
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4125",
    "data-name": "Group 4125",
    transform: "translate(74.916 11.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3932",
    "data-name": "Group 3932",
    transform: "translate(16.423 18.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3931",
    "data-name": "Group 3931"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5415",
    "data-name": "Path 5415",
    d: "M19.3,110.019l-3.5-.219v2.628Z",
    transform: "translate(-14.267 -107.172)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5416",
    "data-name": "Path 5416",
    d: "M18.165,108.6,15.1,110.133l1.752,1.752Z",
    transform: "translate(-15.1 -108.6)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3934",
    "data-name": "Group 3934",
    transform: "translate(9.415 16.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5417",
    "data-name": "Path 5417",
    d: "M15.652,107.6,13.9,111.979h3.284Z",
    transform: "translate(-9.521 -107.6)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3933",
    "data-name": "Group 3933",
    transform: "translate(0 2.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5418",
    "data-name": "Path 5418",
    d: "M11.9,110.019l3.722-.219v2.628Z",
    transform: "translate(-11.9 -107.172)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M12.8,108.6l3.065,1.533-1.752,1.752Z",
    transform: "translate(-10.829 -108.6)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3936",
    "data-name": "Group 3936",
    transform: "translate(9.415 16.422)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5420",
    "data-name": "Path 5420",
    d: "M15.652,107.6,13.9,111.979h3.284Z",
    transform: "translate(-9.521 -107.6)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3935",
    "data-name": "Group 3935",
    transform: "translate(0 2.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5421",
    "data-name": "Path 5421",
    d: "M11.9,110.019l3.722-.219v2.628Z",
    transform: "translate(-11.9 -107.172)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5422",
    "data-name": "Path 5422",
    d: "M12.8,108.6l3.065,1.533-1.752,1.752Z",
    transform: "translate(-10.829 -108.6)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3937",
    "data-name": "Group 3937",
    transform: "translate(11.605 19.925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5423",
    "data-name": "Path 5423",
    d: "M16.841,115.55c-3.065,0-3.722-1.752-3.941-1.971v-.438a3.941,3.941,0,1,1,7.883,0h0C20.564,113.8,20.126,115.55,16.841,115.55Z",
    transform: "translate(-12.9 -109.2)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5424",
    "data-name": "Path 5424",
    d: "M16.841,115.55c-3.065,0-3.722-1.752-3.941-1.971v-.438a3.941,3.941,0,1,1,7.883,0h0C20.564,113.8,20.126,115.55,16.841,115.55Z",
    transform: "translate(-12.9 -109.2)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5425",
    "data-name": "Path 5425",
    d: "M12.522,118.724,8.8,122.446V106.9h2.846Z",
    transform: "translate(-6.172 -92.011)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5426",
    "data-name": "Path 5426",
    d: "M16.9,116.9l-4.379-4.6L8.8,116.022l6.788,10.291Z",
    transform: "translate(-6.172 -85.587)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3023",
    "data-name": "Rectangle 3023",
    width: 8.102,
    height: 5.474,
    transform: "translate(20.221 44.414) rotate(-45)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5427",
    "data-name": "Path 5427",
    d: "M19.768,120.578h0a1.634,1.634,0,0,1,1.971,0l.876.876-1.971,1.971-.876-.876A1.228,1.228,0,0,1,19.768,120.578Z",
    transform: "translate(6.288 -76.13)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3024",
    "data-name": "Rectangle 3024",
    width: 21.896,
    height: 16.422,
    transform: "translate(4.597 77.731)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_522",
    "data-name": "Line 522",
    y2: 11.386,
    transform: "translate(10.071 82.767)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_523",
    "data-name": "Line 523",
    y2: 11.386,
    transform: "translate(21.02 82.767)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_524",
    "data-name": "Line 524",
    y2: 11.386,
    transform: "translate(15.546 82.767)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3025",
    "data-name": "Rectangle 3025",
    width: 24.086,
    height: 2.628,
    transform: "translate(3.504 75.103)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3026",
    "data-name": "Rectangle 3026",
    width: 21.896,
    height: 2.846,
    transform: "translate(4.597 72.257)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3027",
    "data-name": "Rectangle 3027",
    width: 24.086,
    height: 2.628,
    transform: "translate(3.504 69.629)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5428",
    "data-name": "Path 5428",
    d: "M27.422,152.718H11l1.971-28.9,1.314-9.415H24.576Z",
    transform: "translate(-3.555 -83.089)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5429",
    "data-name": "Path 5429",
    d: "M16.246,118.12h0a2.867,2.867,0,0,1-2.846-2.628v-2.846a2.9,2.9,0,0,1,2.846-2.846h0a2.9,2.9,0,0,1,2.846,2.846v2.846A3.042,3.042,0,0,1,16.246,118.12Z",
    transform: "translate(-0.7 -88.561)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5430",
    "data-name": "Path 5430",
    d: "M15.295,116.346h0a1.034,1.034,0,0,1-1.095-1.095V113.5h2.19v1.752A1.034,1.034,0,0,1,15.295,116.346Z",
    transform: "translate(0.251 -84.159)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_525",
    "data-name": "Line 525",
    y1: 11.605,
    x2: 11.605,
    transform: "translate(9.415 31.311)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_526",
    "data-name": "Line 526",
    x1: 13.576,
    y2: 13.576,
    transform: "translate(8.319 42.478)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_527",
    "data-name": "Line 527",
    x1: 15.108,
    y2: 15.108,
    transform: "translate(7.445 54.083)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_528",
    "data-name": "Line 528",
    y2: 12.043,
    transform: "translate(19.05 57.586)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5431",
    "data-name": "Path 5431",
    d: "M17.2,114.4l3.941,8.32-3.065,3.065Z",
    transform: "translate(3.821 -83.089)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3028",
    "data-name": "Rectangle 3028",
    width: 8.32,
    height: 1.752,
    transform: "translate(0 8.32)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_529",
    "data-name": "Line 529",
    y2: 7.007,
    transform: "translate(4.16 10.51)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5432",
    "data-name": "Path 5432",
    d: "M12.96,107.033h0a1.413,1.413,0,0,1-1.314,1.314H8.8V105.5h2.846A1.878,1.878,0,0,1,12.96,107.033Z",
    transform: "translate(-6.172 -93.676)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_530",
    "data-name": "Line 530",
    x2: 3.722,
    transform: "translate(2.189 10.51)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5433",
    "data-name": "Path 5433",
    d: "M9.5,108.421a2.638,2.638,0,0,1-.657-3.941A4.87,4.87,0,0,0,9.5,100.1a5.856,5.856,0,0,1,4.379,4.16c.657,3.065-1.314,3.941-1.314,3.941l-3.065.219Z",
    transform: "translate(-6.876 -100.1)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5434",
    "data-name": "Path 5434",
    d: "M29.78,133.456l-3.941-3.941a.666.666,0,0,0-.876,0l-.438.438-3.5-7.664c0-.219-.219-.219-.438-.219H16.642v-1.095a3.743,3.743,0,0,0,1.533-2.846v-.657a2.643,2.643,0,0,0,1.095-1.752h0v-.876l1.971-1.314a.8.8,0,0,0,.219-.657.471.471,0,0,0-.438-.438l-2.409-.219.876-1.752a.774.774,0,0,0-.876-.876L16.2,110.684l-1.095-2.846c0-.219-.438-.438-.657-.438s0,78.826,0,78.826H25.62a.7.7,0,0,0,.657-.657V169.585h.438c.219,0,.438-.219.438-.657V166.3c0-.219-.219-.438-.657-.438h-.438v-1.752h.657c.219,0,.438-.219.438-.657v-2.628c0-.219,0-.219-.219-.438a.764.764,0,0,0-.438-.219H23.211l-.876-20.8.876.876a.666.666,0,0,0,.876,0l1.533-1.533.657.657a.666.666,0,0,0,.876,0l1.971-1.971a.666.666,0,0,0,0-.876l-.657-.657L30,134.332A1.316,1.316,0,0,0,29.78,133.456Z",
    transform: "translate(0.437 -91.416)",
    fill: "#536dfe",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4122",
    "data-name": "Group 4122",
    transform: "translate(122.346 6.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3954",
    "data-name": "Group 3954",
    transform: "translate(0 16.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5446",
    "data-name": "Path 5446",
    d: "M149.8,149.376h8.11l6.164-20.276h-7.137Z",
    transform: "translate(-149.8 -66.326)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5448",
    "data-name": "Path 5448",
    d: "M166.779,90.4h-4.055l-4.055,36.5L155.1,149.119h6.488l2.433-22.222Z",
    transform: "translate(-146.503 -90.4)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5599",
    "data-name": "Path 5599",
    d: "M7.765,0",
    transform: "translate(5.861 64.883)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5598",
    "data-name": "Path 5598",
    d: "M5.449,0",
    transform: "translate(11.583 40.552)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5597",
    "data-name": "Path 5597",
    d: "M4.632,0",
    transform: "translate(14.185 17.843)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3955",
    "data-name": "Group 3955",
    transform: "translate(20.437 16.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5452",
    "data-name": "Path 5452",
    d: "M180.212,149.376H172.1l-6-20.276h7.137Z",
    transform: "translate(-160.098 -66.326)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5453",
    "data-name": "Path 5453",
    d: "M166.749,131.209h7.137l-.649-2.109H166.1Z",
    transform: "translate(-160.098 -66.326)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5454",
    "data-name": "Path 5454",
    d: "M162.4,90.4h4.055l3.893,36.5,3.731,22.222h-6.488L165.158,126.9Z",
    transform: "translate(-162.4 -90.4)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5458",
    "data-name": "Path 5458",
    d: "M171.663,131.209H158.2l.649-2.109h12.166Z",
    transform: "translate(-144.576 -50.105)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3036",
    "data-name": "Rectangle 3036",
    width: 8.11,
    height: 4.055,
    transform: "translate(16.22 12.166)",
    fill: "#cbd3ff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5459",
    "data-name": "Path 5459",
    d: "M166.749,131.209h7.137l-.649-2.109H166.1Z",
    transform: "translate(-139.66 -50.105)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3037",
    "data-name": "Rectangle 3037",
    width: 26.44,
    height: 4.055,
    transform: "translate(7.136 74.94)",
    fill: "#cbd3ff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3038",
    "data-name": "Rectangle 3038",
    width: 17.518,
    height: 4.055,
    transform: "translate(11.517 52.718)",
    fill: "#cbd3ff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3039",
    "data-name": "Rectangle 3039",
    width: 2.433,
    height: 12.166,
    transform: "translate(19.14)",
    fill: "#cbd3ff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_567",
    "data-name": "Line 567",
    x2: 17.681,
    transform: "translate(11.517 54.664)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5461",
    "data-name": "Path 5461",
    d: "M173.3,134.455s-2.271-2.109-7.948-2.109-7.948,2.109-7.948,2.109l1.3-4.055h13.463Z",
    transform: "translate(-145.072 -49.296)",
    fill: "#cbd3ff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4123",
    "data-name": "Group 4123",
    transform: "translate(9.316 70.236)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3940",
    "data-name": "Group 3940",
    transform: "translate(38.862 37.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5435",
    "data-name": "Path 5435",
    d: "M-35.6,161.412h6.98V156.7l-.566-11.7h-5.659l-.755,11.7Z",
    transform: "translate(35.6 -145)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5436",
    "data-name": "Path 5436",
    d: "M-35.6,152.264h6.98V150h-6.791Z",
    transform: "translate(35.6 -140.568)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3945",
    "data-name": "Group 3945",
    transform: "translate(0 34.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3941",
    "data-name": "Group 3941",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6_",
    width: 155.634,
    height: 2.452,
    fill: "#cbd3ff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3943",
    "data-name": "Group 3943",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3942",
    "data-name": "Group 3942",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3029",
    "data-name": "Rectangle 3029",
    width: 155.634,
    height: 1.132,
    transform: "translate(0 1.132)",
    fill: "#cbd3ff",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3944",
    "data-name": "Group 3944",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3031",
    "data-name": "Rectangle 3031",
    width: 155.634,
    height: 2.452,
    fill: "none",
    stroke: "#536dfe",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3946",
    "data-name": "Group 3946",
    transform: "translate(4.528 5.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5437",
    "data-name": "Path 5437",
    d: "M-18.334,128.2S-33.049,150.46-53.8,157.44",
    transform: "translate(53.8 -128.2)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_531",
    "data-name": "Line 531",
    y1: 15.092,
    transform: "translate(23.392 14.149)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_532",
    "data-name": "Line 532",
    y1: 23.958,
    transform: "translate(31.504 5.282)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_533",
    "data-name": "Line 533",
    y1: 3.207,
    transform: "translate(7.357 26.033)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_534",
    "data-name": "Line 534",
    y1: 8.3,
    transform: "translate(15.28 20.94)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3947",
    "data-name": "Group 3947",
    transform: "translate(45.088 5.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5438",
    "data-name": "Path 5438",
    d: "M-32.3,128.2S-18.529,150.46.713,157.44",
    transform: "translate(32.3 -128.2)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_535",
    "data-name": "Line 535",
    y1: 15.092,
    transform: "translate(11.13 14.149)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_536",
    "data-name": "Line 536",
    y1: 23.958,
    transform: "translate(3.773 5.282)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_537",
    "data-name": "Line 537",
    y1: 3.207,
    transform: "translate(26.222 26.033)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_538",
    "data-name": "Line 538",
    y1: 8.3,
    transform: "translate(18.676 20.94)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3948",
    "data-name": "Group 3948",
    transform: "translate(79.422 5.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5439",
    "data-name": "Path 5439",
    d: "M18.913,128.2S5.142,150.46-14.1,157.44",
    transform: "translate(14.1 -128.2)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_539",
    "data-name": "Line 539",
    y1: 15.092,
    transform: "translate(21.694 14.149)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_540",
    "data-name": "Line 540",
    y1: 23.958,
    transform: "translate(29.24 5.282)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_541",
    "data-name": "Line 541",
    y1: 3.207,
    transform: "translate(6.791 26.033)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_542",
    "data-name": "Line 542",
    y1: 8.3,
    transform: "translate(14.149 20.94)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3949",
    "data-name": "Group 3949",
    transform: "translate(39.427 0.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3032",
    "data-name": "Rectangle 3032",
    width: 4.716,
    height: 36.598,
    transform: "translate(0.566 0.189)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3033",
    "data-name": "Rectangle 3033",
    width: 5.659,
    height: 2.452,
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5440",
    "data-name": "Path 5440",
    d: "M9.769,161.412H2.6V156.7L3.355,145H9.014l.755,11.7Z",
    transform: "translate(108.327 -107.648)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5441",
    "data-name": "Path 5441",
    d: "M9.769,152.264H2.6L2.789,150H9.58Z",
    transform: "translate(108.327 -103.215)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3950",
    "data-name": "Group 3950",
    transform: "translate(116.773 5.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5442",
    "data-name": "Path 5442",
    d: "M5.7,128.2s14.714,22.26,35.466,29.24",
    transform: "translate(-5.7 -128.2)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_543",
    "data-name": "Line 543",
    y1: 15.092,
    transform: "translate(12.073 14.149)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_544",
    "data-name": "Line 544",
    y1: 23.958,
    transform: "translate(4.15 5.282)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_545",
    "data-name": "Line 545",
    y1: 3.207,
    transform: "translate(28.297 26.033)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_546",
    "data-name": "Line 546",
    y1: 8.3,
    transform: "translate(20.185 20.94)",
    fill: "none",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3034",
    "data-name": "Rectangle 3034",
    width: 4.716,
    height: 36.598,
    transform: "translate(112.059 0.755)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3035",
    "data-name": "Rectangle 3035",
    width: 5.659,
    height: 2.452,
    transform: "translate(111.68 0.755)",
    fill: "#fff",
    stroke: "#536dfe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5443",
    "data-name": "Path 5443",
    d: "M8.462,174.248v-.943l-.755-10.753a.406.406,0,0,0-.377-.377V128.784a.6.6,0,0,0,.566-.566v-2.452a.6.6,0,0,0-.566-.566H4.5v54.33H8.084a.6.6,0,0,0,.566-.566l-.189-4.716Z",
    transform: "translate(110.01 -125.2)",
    fill: "#536dfe",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5444",
    "data-name": "Path 5444",
    d: "M-30.327,174.248v-.943l-.566-10.753a.406.406,0,0,0-.377-.377V128.784a.6.6,0,0,0,.566-.566v-2.452a.6.6,0,0,0-.566-.566H-34.1v54.33h3.584a.6.6,0,0,0,.566-.566l-.377-4.716Z",
    transform: "translate(75.792 -125.2)",
    fill: "#536dfe",
    opacity: 0.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourPackages);
export default __webpack_public_path__ + "static/media/tour-packages.0cc8674e.svg";
export { ForwardRef as ReactComponent };